import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/inPersonTraining/eventOverview/associatedContent';
import { withTooltip } from 'components/shared/Tooltip';
import { Icon } from 'ui';
import { AssociatedContentItem } from '../types';

const RemoveContentItem = ({ contentItem, removeAssociatedContentItem }) => {
  const handleRemoveItem = () =>
    removeAssociatedContentItem(contentItem.association_id);

  return (
    <>
      {withTooltip({
        text: t('in_person_training.event_content.remove_content'),
        position: 'top',
        inline: true,
      })(
        <div
          onClick={handleRemoveItem}
          onKeyDown={e =>
            (e.key === 'Enter' || e.key === ' ') && handleRemoveItem
          }
          role="button"
          tabIndex="0"
          className="h-100 d-f ai-c pl-8"
        >
          <Icon name="close" className="c-midnight-90" />
        </div>,
      )}
    </>
  );
};

RemoveContentItem.propTypes = {
  contentItem: AssociatedContentItem.isRequired,
  removeAssociatedContentItem: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  removeAssociatedContentItem: associationId =>
    actions.removeAssociatedContentItem(associationId),
};

export default connect(null, mapDispatchToProps)(RemoveContentItem);
